import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Users", -1)

import EditableDataGrid from '@/components/EditableDataGrid.vue'

	import { defineComponent, Ref, ref } from 'vue';
	import { User } from '@/interfaces/User'
	import UserForm from '@/components/UserForm.vue'
	import UserPassword from '@/components/UserPasswordForm.vue'
	import DeleteConfirmationForm from '@/components/DeleteConfirmationForm.vue'
	import { GridColumn } from '@/interfaces/Grid';
	import { FormatterService } from '@/services/FormatterService';
	import { ModalService } from '@/services/ModalService';
	interface Data {
		newItem: Ref<User>,
		headers: Array<GridColumn>,
		editableEntity: User,
	}
	const __default__ = defineComponent({
		name: 'UsersView',
		data(): Data {
			const entity = this.getDefaultEntity();
			return {
				newItem: ref(entity),
				headers: [
					{
						title: 'ID',
						sortable: true,
						key: 'id',
						align: 'end',
						width: '50px',
					},
					{ title: 'Username', key: 'username', align: 'start', },
					{ title: 'Last Name', key: 'lastName', align: 'start', },
					{ title: 'First Name', key: 'firstName', align: 'start', },
					{ title: 'Create date', key: 'createDate', align: 'start', formatter: FormatterService.defaultDate() },
					{ title: 'Update', key: 'updateDate', align: 'start', formatter: FormatterService.defaultDate() },
					{ title: 'Actions', key: 'actions', sortable: false, align: 'end', width: '120px' },
				],
				editableEntity: entity,
			}
		},
		methods: {
			getDefaultEntity(): User {
				return {
					id: 0,
					username: '',
				};
			},
			changePassword(item: User, index: number): void {
				this.editableEntity = {
					...item
				};
				ModalService
					.show(UserPassword, {
						propEntity: this.editableEntity
					})
					.then(() => {
					})
			}
		}
	})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	
return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "mb-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "text-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "indigo-darken-3",
              variant: "flat",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.newItem = _ctx.getDefaultEntity()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" New User ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(EditableDataGrid, {
      propAddItem: _ctx.newItem,
      "onUpdate:propAddItem": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newItem) = $event)),
      propHeaders: _ctx.headers,
      propController: 'user',
      propEditForm: UserForm,
      propDeleteForm: DeleteConfirmationForm,
      propDefaultEntity: _ctx.editableEntity
    }, {
      cellTemplate: _withCtx(({ header, item, formatCell, deleteItem, index, editItem }) => [
        (header.key == 'actions')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_v_icon, {
                size: "small",
                class: "me-2",
                onClick: ($event: any) => (_ctx.changePassword(item.raw, index))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" mdi-lock-reset ")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_v_icon, {
                size: "small",
                class: "me-2",
                onClick: ($event: any) => (editItem(item.raw))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" mdi-pencil ")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_v_icon, {
                size: "small",
                onClick: ($event: any) => (deleteItem(item.raw))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" mdi-delete ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(formatCell(header, item.raw[header.key])), 1)
            ], 64))
      ]),
      _: 1
    }, 8, ["propAddItem", "propHeaders", "propDefaultEntity"])
  ], 64))
}
}

})